module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.json) ? _c('div', [_c('div', {
    staticClass: "panel panel-primary"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v(_vm._s(_vm.json.name))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('resourceTemplate', {
    ref: "content",
    attrs: {
      "resource": _vm.template,
      "componentData": _vm.componentData
    }
  }), _vm._v(" "), _c('schedulerPicker', {
    ref: "schedulerPicker",
    attrs: {
      "json": _vm.json
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_vm._v("\n            Dependencies: "), _vm._l((_vm.json.dependencies), function(d) {
    return _c('span', {
      staticClass: "label label-primary dependency"
    }, [_vm._v(_vm._s(d))])
  })], 2)])]) : (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-39520732!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tutorialPicker/TutorialDetails.vue
// module id = 1537
// module chunks = 2